export class NoContentResponse {
    public static readonly status = 204;
}
